var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlarms = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6,11.2h0V5.6a5.6,5.6,0,0,0-11.2,0v5.6L0,13.5v1.1H18V13.5Zm0,2.3H2l2-1.3.5-.3V5.6a4.5,4.5,0,0,1,9,0v6.2l.5.3,2,1.3H14.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,18a2.22,2.22,0,0,0,2.2-2.2H6.8A2.22,2.22,0,0,0,9,18Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlarms);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alarms.f7383a6d76afdd599ff9cca3b283b40f.svg";